import { useEffect } from "react";
import { Cross2Icon } from "@radix-ui/react-icons";
import { useSelector } from "@legendapp/state/react";
import { ExtendedBin } from "./types";
import { Observable } from "@legendapp/state";
import { Rnd } from "react-rnd";
import { IconButton } from "@radix-ui/themes";

export function BinInfoPopup({
  selected$,
}: {
  selected$: Observable<ExtendedBin | null>;
}) {
  const bin = useSelector(() => selected$.get());

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        selected$.set(null);
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, []);

  if (!bin) return null;

  return (
    <Rnd
      className="z-[9999]"
      bounds=".virtual-store"
      dragHandleClassName="header"
      enableResizing={false}
      default={
        {
          x: 20,
          y: window.innerHeight - 224 - 300,
        } as any
      }
    >
      <div
        className="w-[360px] text-base bg-white font-bold shadow-lg rounded-lg"
        onMouseEnter={(e) => {
          e.stopPropagation();
        }}
      >
        <div className="header flex justify-between border-b px-4 py-3 border-gray-200 mb-2">
          <p className="text-md font-semibold text-slate-800">Bin info</p>
          <IconButton
            color="gray"
            variant="soft"
            onClick={(e) => {
              e.stopPropagation();
              selected$.set(null);
            }}
            className="absolute top-2 right-2"
          >
            <Cross2Icon />
          </IconButton>
        </div>
        <div className="px-4 py-2">
          <div className="flex gap-2 mb-2 items-center">
            <figure className="min-w-20 w-20 h-20">
              <img
                className="object-contain w-full h-full"
                src={bin.variant?.image as string}
              />
            </figure>
            <p className="text-md font-medium text-slate-800">
              {bin.variant?.display_name || "Product variant doesn't exist"}
            </p>
          </div>
          <ul className="text-sm pl-2 text-slate-700 font-medium">
            <li className="py-1">SKU: {bin.variant?.sku ?? "N/A"}</li>
            <li className="py-1">SKU ID: {bin.variant?.id ?? "N/A"}</li>
            <li className="py-1">Bin ID: {bin.id}</li>
            <li className="py-1">G-Sh-B order: {bin.description}</li>
          </ul>
        </div>
      </div>
    </Rnd>
  );
}
